<template>
  <div class="story">
    <div :class="isSP ? 'story__element--sp' : 'story__element--pc'"
         v-for="(item, n) in items" :key="item.title">
      <v-img :class="isSP ? 'story__element__img--sp' : 'story__element__img--pc'"
             :src="require('@/assets/img/story' + (n + 1) + '.jpeg')" />
      <h2 :class="isSP ? 'story__element__title--sp' : 'story__element__title--pc'">{{ item.title }}</h2>
      <p :class="isSP ? 'story__element__texts--sp' : 'story__element__texts--pc'">{{ item.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 表示する内容
      items: [
        {
          title: '世界食料デーにグランドオープン',
          text: '2019年10月16日、世界食料デーにお店をオープンしました。様々な人たちのご協力のもと、「フードロスの飲食店をやろう」というアイデアからなんと1ヶ月でお店をオープンすることができました。'
        },
        {
          title: '6名の学生が参戦',
          text: 'オープンに向けて、立命館アジア太平洋大学から6名の学生がお店の立ち上げをサポートしてくれました。'
        },
        {
          title: '提携先の小売店',
          text: 'フードロスを快く提供してくれた方たちのおかげで、お店を運営することができました。八百屋さんや精肉店さんから食材を定期的に頂いていました。'
        },
        {
          title: '提携先の飲食店',
          text: '八百屋さんや精肉店以外にも、飲食店の方たちからもフードロスを頂きました。ハンバーガー屋さんのトマトや、火鍋屋さんのお肉と野菜も活用していました。'
        },
        {
          title: 'おいしく、おしゃれに',
          text: 'フードロスのイメージを変えるために、集まったものをおいしくおしゃれに提供しました。料理はその日の食材で決めています。'
        },
        {
          title: 'SDG’sがテーマの様々な大会で受賞',
          text: '社会起業として、SDG’s関連の大会でたくさんの賞をいただきました。CHALLENGE FUTURE AWARDでは社会起業家賞、ザイナス賞。立命館大学主催の総長ピッチではSony Startup Acceleration Program賞などを受賞。'
        },
        {
          title: 'メディアにも多数出演',
          text: 'テレビ、新聞、ラジオ、ウェブメディアに多数出演させていただきました。NHK、大分新聞、など。'
        },
        {
          title: '活用したフードロスは203kg以上',
          text: 'フードロスはすべて計測していました。2020年1月26日のフィナーレパーティ時に計測したフードロスの量は203.9kgでした。一般的な原付バイク3台弱分です。'
        }
      ]
    }
  },
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.story {
  width: 100vw;
  text-align: center;
  &__element {
    position: relative;
    width: 100%;
    &--sp {
      @extend .story__element;
      padding: 0 40px;
      margin-top: 40px;
    }
    &--pc {
      @extend .story__element;
      padding: 0 calc((100vw - 800px) / 2);
      margin-top: 100px;
    }
    &:first-child {
      margin-top: 0;
    }
    &__img {
      margin: 0 auto;
      &--sp {
        @extend .story__element__img;
        width: 100%;
        min-height: 175px;
      }
      &--pc {
        @extend .story__element__img;
        width: 100%;
        min-height: 500px;
      }
    }
    &__title {
      position: absolute;
      width: 100%;
      font-weight: normal;
      color: $white_color;
      &--sp {
        @extend .story__element__title;
        top: calc((175px / 2) - (21px / 2));
        left: 50%;
        font-size: 1.4rem;
        line-height: 2.1rem;
        transform: translate(-50%, 0);
      }
      &--pc {
        @extend .story__element__title;
        top: 280px;
        left: calc((100vw - 800px) / 2);
        max-width: 800px;
        padding: 0 50px;
        font-size: 3.4rem;
        text-align: left;
      }
    }
    &__texts {
      margin: 0;
      text-align: left;
      &--sp {
        @extend .story__element__texts;
        margin-top: 10px;
        font-size: 1.2rem;
      }
      &--pc {
        @extend .story__element__texts;
        position: absolute;
        top: 354px;
        left: calc((100vw - 800px) / 2);
        display: block;
        max-width: 800px;
        padding: 0 50px;
        font-size: 1.8rem;
        color: $white_color;
      }
    }
  }
}
</style>
